const BasePath = '/';

const Routes = {
  DashboardPage: '/',
  MyPropertyPage: '/my-property',
  MyPropertyBuyingPage: '/my-property/buying/*',
  ProfilePage: '/profile',
  LoginPage: '/login',
  SignUpPage: '/signup',
  ResetPassEmailPage: '/forgot-password',
  ResetPassPage: '/reset-password',
  CalendarPage: '/calendar',
  InboxPage: '/inbox',
  NotFoundPage: '/404',
};

module.exports = {};
Object.entries(Routes).forEach(([key, value]) => {
  module.exports[value] = key;
});

module.exports.Routes = Routes;
module.exports.BasePath = BasePath;
